module.exports = __webpack_public_path__ + "img/health1_7-9-2021.ec1424b4.jpg";